import {
  Box,
  Button,
  Container,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { ReactComponent as Logo } from "../resources/svg/logo.svg";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { IoMenu } from "react-icons/io5";

const navHomeItems = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "#aboutUs" },
  { name: "Projects", href: "#projects" },
  { name: "Our Process", href: "#ourProcess" },
  // { name: "Testimonials", href: "#testimonials" },
  { name: "Contact", href: "#contact" },
];

const Navbar = () => {
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 280,
        background: "white",
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        {/* <img src={Logo} alt="illustrator" style={{ height: "50px" }} /> */}
        <Logo style={{ height: "50px" }} />
      </Box>
      <List
        sx={{
          backgroundColor: "white !important",
          color: "#000 !important",
        }}
      >
        {navHomeItems.map((item, index) => (
          <HashLink
            to={item.href}
            style={{ textDecoration: "none", color: "#000" }}
          >
            <ListItem key={item.name} disablePadding>
              <ListItemButton
                sx={{
                  paddingX: "20px",
                  borderBottom:
                    index !== navHomeItems.length - 1
                      ? "1px solid rgba(145, 158, 171, 0.24)"
                      : "none",
                }}
                component="a"
                href={item.link}
              >
                <ListItemText
                  primary={item.name}
                  sx={{
                    ".MuiTypography-root": {
                      fontWeight: 600,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          </HashLink>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <Box>
        <Box
          sx={{
            background: "#DFD1C9",
            backdropFilter: "blur(10px)",
          }}
        >
          <Container
            maxWidth="xl"
            sx={{ pl: "0 !important", pr: "0 !important" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "space-between", md: "space-evenly" },
                paddingX: { xs: 2 },
                paddingTop: { xs: 0, md: "3px" },
                // paddingBottom: { xs: 0, md: "17.31px" },
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: {
                    xs: "none",
                    md: "flex",
                  },
                  gap: 7,
                }}
              >
                <HashLink
                  to="#aboutUs"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "800",
                      marginBottom: "10px",
                      color: "#716D64",
                      mb: 0,
                      fontSize: {
                        xs: "18px",
                      },
                      display: {
                        xs: "none",
                        sm: "block",
                      },
                    }}
                    variant="h3"
                  >
                    About Us
                  </Typography>
                </HashLink>
                <HashLink
                  to="#projects"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "800",
                      marginBottom: "10px",
                      color: "#716D64",
                      mb: 0,
                      fontSize: {
                        xs: "18px",
                      },
                      display: {
                        xs: "none",
                        sm: "block",
                      },
                    }}
                    variant="h3"
                  >
                    Projects
                  </Typography>
                </HashLink>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    cursor: "pointer",
                    lineHeight: "normal",
                    "& svg": {
                      width: { xs: 100, md: 150 },
                    },
                  }}
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <Logo />
                </Box>
              </Box>
              <Box
                sx={{
                  display: {
                    xs: "none",
                    md: "flex",
                  },
                  gap: 7,
                }}
              >
                <HashLink
                  to="#ourProcess"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "800",
                      marginBottom: "10px",
                      color: "#716D64",
                      mb: 0,
                      fontSize: {
                        xs: "18px",
                      },
                      display: {
                        xs: "none",
                        sm: "block",
                      },
                    }}
                    variant="h3"
                  >
                    Our Process
                  </Typography>
                </HashLink>
                <HashLink
                  to="#contact"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "800",
                      marginBottom: "10px",
                      color: "#716D64",
                      mb: 0,
                      fontSize: {
                        xs: "18px",
                      },
                      display: {
                        xs: "none",
                        sm: "block",
                      },
                    }}
                    variant="h3"
                  >
                    Contact Us
                  </Typography>
                </HashLink>
              </Box>
              <Box
                sx={{
                  display: {
                    xs: "block",
                    md: "none",
                    // lg: "flex",
                  },
                  opacity: {
                    xs: 1,
                    md: 0,
                  },
                  justifyContent: "end",
                  width: { xs: "50px", sm: "60px", md: "80px" },
                }}
              >
                <Button
                  onClick={toggleDrawer("right", true)}
                  sx={{
                    minWidth: "40px",
                    minHeight: "40px",
                    height: "40px",
                    padding: 0,
                  }}
                >
                  <IoMenu color="#444" size={32} />
                </Button>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer("right", false)}
      >
        {list("right")}
      </Drawer>
    </>
  );
};

export default Navbar;
